<template>
  <div>
    <!-- Header -->
    <Header
      :total="journeyLength"
      :percentages="computedSHEF"
      @toogleEditMode="toogleEdit"
    ></Header>
    <!-- Header -->
    <!-- Search Journey -->
    <Search
      :total="journeyLength"
      :lastUpdated="lastUpdated"
      @resetSearch="resetSearch"
      @filterSearch="filterSearch"
    ></Search>

    <!-- Search Journey -->
    <!-- My Journeys -->
    <Journeys
      :journeys="journeys"
      @editJourney="editJourney"
      @archiveJourney="archiveJourney"
      @addFocus="addFocus"
    ></Journeys>
    <!-- My Journeys -->
    <Addjourney
      @addJourney="addJourney"
      @addJourneys="addJourneys"
      :journey="editedJourney"
      :journeys="journeysToAdd"
      :editMode="editMode"
      @updateJourney="updateJourney"
      @clearTemp="editedJourney = undefined"
    ></Addjourney>
    <modal id="archiveJourney" size="sm">
      <div class="add-faq del-faq">
        <span class="close-icon" @click="$bvModal.hide('archiveJourney')">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Archive Journey</h3>
        <div class="warning-msg">
          <p v-if="archiveIndex !== -1">
            Are you sure want to archive
            {{ journeys[archiveIndex].text }} Journey?
          </p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button
            variant="danger btn-round-fill"
            @click="$bvModal.hide('archiveJourney')"
          >
            No! back
          </b-button>
          <b-button variant="light btn-simple" @click="confirmArchiveJourney">
            Yes! Archive
          </b-button>
          <!-- light btn-simple -->
        </div>
      </div>
    </modal>
    <create-focus
      :id="journeyFocus"
      :journey="selectedJourney"
      :key="refreshKey"
      @focus-created="saveFocus"
    />
    <!-- <Editjourney :editedJourney="editedJourney"></Editjourney> -->
  </div>
</template>

<script>
import Header from "./header";
import Search from "./search";
import Journeys from "./journeys";
import Addjourney from "./addJourney";
import { mapGetters } from "vuex";
import Modal from "@/components/common/modal";
import createFocus from "@/components/jab/createFocus";
export default {
  components: {
    Header,
    Search,
    Journeys,
    Addjourney,
    Modal,
    createFocus
  },
  data() {
    return {
      journeyFocus: "journey-focus",
      editMode: false,
      currId: null,
      tempId: null,
      editedJourney: undefined,
      editIndex: -1,
      refreshKey: 1,
      refreshAdd: 3,
      archiveIndex: -1,
      lastUpdated: null,
      selectedJourney: null,
      journeys: [],
      journeysToAdd: []
    };
  },
  computed: {
    ...mapGetters({
      allJourneys: "user/listJourneys"
    }),
    journeyLength() {
      if (this.activeJourneys.length) {
        return this.activeJourneys.length;
      } else {
        return 0;
      }
    },
    activeJourneys() {
      let journeys = [];
      this.allJourneys.forEach(journey => {
        if (!journey._archived_at) {
          journeys.push(journey);
        }
      });
      return journeys;
    },
    computedSHEF() {
      let totalS = 0;
      let totalH = 0;
      let totalE = 0;
      let totalF = 0;

      this.activeJourneys.forEach((aJourney, i) => {
        // debugger;
        let focuses = aJourney.spheres;
        if (focuses.includes("s")) totalS++;
        if (focuses.includes("h")) totalH++;
        if (focuses.includes("e")) totalE++;
        if (focuses.includes("f")) totalF++;
      });
      let totalSHEF = totalS + totalH + totalE + totalF;

      return {
        s: ((totalS / totalSHEF) * 100).toFixed(2),
        h: ((totalH / totalSHEF) * 100).toFixed(2),
        e: ((totalE / totalSHEF) * 100).toFixed(2),
        f: ((totalF / totalSHEF) * 100).toFixed(2)
      };
    }
  },
  mounted() {
    this.getJourneys();
  },
  watch: {
    activeJourneys(newValue, oldValue) {
      if (newValue) {
        this.journeys = newValue;
      }
    }
  },
  methods: {
    getJourneys() {
      this.$store.dispatch("user/getListJourneys").then(res => {
        if (res._updated_at) {
          this.lastUpdated = res._updated_at;
        }
      });
    },
    addJourney(journey) {
      console.log("single");
      console.log(journey);
      this.$store
        .dispatch("user/addJourney", journey)
        .then(res => {
          if (res) {
            return this.$store.dispatch("user/getListJourneys").then(() => {
              console.log("successfully added new journey");
            });
          }
        })
        .catch(err => {
          console.log("error in adding new journey: ", err);
        });
    },
    addJourneys(journeys) {
      console.log("multiple");
      console.log(journeys);
      this.$store
        .dispatch("user/addJourneys", journeys)
        .then(res => {
          if (res) {
            return this.$store.dispatch("user/getListJourneys").then(() => {
              console.log("successfully added new journeys");
            });
          }
        })
        .catch(err => {
          console.log("error in adding new journey: ", err);
        });
    },
    editJourney(index) {
      this.editIndex = index;
      this.editedJourney = this.journeys[index];
      this.editMode = true;
      this.$bvModal.show("my-journeys");
    },
    updateJourney(journey) {
      console.log(journey);
      this.editedJourney = undefined;
      this.editIndex = -1;
      this.$store.dispatch("user/updateJourney", journey).then(res => {
        console.log("Journey Updated");
      });
    },
    archiveJourney(index) {
      this.$bvModal.show("archiveJourney");
      this.archiveIndex = index;
    },
    confirmArchiveJourney() {
      this.$store
        .dispatch("user/archiveJourney", this.journeys[this.archiveIndex])
        .then(res => {
          this.getJourneys();
          this.$store.dispatch("user/showNotification", {
            title: "Successfully Archived",
            description: "Your Journey has been achived successfully.",
            variant: "success"
          });
        });
      this.$bvModal.hide("archiveJourney");
    },
    resetSearch() {
      this.journeys = this.activeJourneys;
    },
    filterSearch(search) {
      this.journeys = this.activeJourneys.filter(journey => {
        return journey.text.toLowerCase().includes(search.toLowerCase().trim());
      });
    },
    addFocus(journey) {
      this.selectedJourney = journey;
      console.log(journey);
      this.$bvModal.show(this.journeyFocus);
    },
    saveFocus(path) {
      this.selectedJourney.focuses.push(path);
      this.$store
        .dispatch("user/updateJourney", this.selectedJourney)
        .then(res => {
          this.refreshKey++;
          this.selectedJourney = null;
          console.log("Journey Updated");
        });
    },
    toogleEdit() {
      this.editMode = false;
      this.journeysToAdd = [];
    }
  }
};
</script>

<style scoped lang="scss">
.add-faq {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-faq {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}
</style>
